<template>
  <div>
    <div class="card-item secondary">
      <b-collapse :open="false">
        <template #trigger="props">
          <b-switch
            id="type-switch"
            v-model="isSwitched"
            :aria-expanded="props.open">
            <h5 class="is-size-5">{{ $t('transactions.createWalletEntryTitle') }}</h5>
          </b-switch>
        </template>
        <br>
        <div class="content">
          <div id="modifier-items">
            <div>
              <b-select id="type-select" v-model="selectedOption" size="is-small">
                <option value="condone">Perdonazo</option>
              </b-select>
            </div>
            <div>
              <span>{{ $t('generalWords.Amount') }} ({{ $t('currency.symbol') }}): </span><b-input
                id="confirm-input"
                v-model="amountField"
                size="is-small"
                class="text"
                type="number"
                @keyup.native="validateInputs" />
            </div>
            <div>
              <b-button
                id="confirm-button"
                :disabled="!checkUserFeature('element.transaction-approval.button.confirm-payment')"
                rounded
                size="is-small"
                :class="`is-button-primary ${isLoading ? 'is-loading' : ''}`"
                @click="createWalletEntry">
                {{ $t('transactions.addWalletEntry') }}
              </b-button>
            </div>
          </div>
          <div v-if="errorMessage">
            <p class="help is-danger"> {{ errorMessage }} </p>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import { createWalletEntryForInterestDiscount } from '@/application/services/api-clients/transactions';
import userFeatures from '@/ui/mixins/user-features';

export default {
  // mixins: [userFeatures],
  props: ['transaction'],
  data() {
    return {
      isLoading: false,
      errorMessage: '',
      amountField: '',
      isSwitched: false,
      selectedOption: 'condone',
      amount: 0,
      description: '',
      origin: '',
      increase: true,
      transactionId: '',
      walletId: '',
      createWallet: {}
    };
  },
  methods: {
    // Por algún motivo el mixins no funciona en este modulo.
    checkUserFeature(name) {
      return userFeatures.methods.checkUserFeature(name, this.$store);
    },
    alert({ message, alertType }) {
      this.$buefy.notification.open({
        id: 'alert-type',
        duration: 3000,
        message,
        type: alertType,
        hasIcon: true
      });
    },
    validateInputs(event) {
      this.errorMessage = '';
      if (event) {
        if (event.keyCode === 190 || event.keyCode === 86 || event.keyCode === 91 || event.keyCode === 17) {
          this.alert({ message: 'Ingresa un monto sin puntos', alertType: 'is-danger' });
          this.amountField = '';
          return false;
        }
      }
      if (Number(this.amountField) < 1) {
        this.alert({ message: 'Debes indicar un monto mayor a 0', alertType: 'is-danger' });
        return false;
      }
      return true;
    },
    async createWalletEntry() {
      this.isLoading = true;
      if (!this.validateInputs()) {
        this.isLoading = false;
        return;
      }
      try {
        const userWhoCreatedTheEntry = this.$store.state.currentUser.user.email;
        this.amount = Number(this.amountField);
        this.description = `Abono realizado por ${userWhoCreatedTheEntry} por concepto de eximisión de diferencia en transacción id: ${this.transaction._id}`;
        this.origin = 'EXCUSE_DIFFERENCE';
        this.transactionId = this.transaction._id;
        this.walletId = this.transaction.client.walletId;
        this.createWallet = await createWalletEntryForInterestDiscount(
          this.amount,
          this.description,
          this.increase,
          this.transactionId,
          this.walletId,
          this.origin
        );
        this.alert({ message: 'El Abono a la wallet por concepto de perdonazo se ha realizado correctamente.', alertType: 'is-success' });
        this.amountField = '';
      } catch (_error) {
        this.errorMessage = 'Ocurrió un error al tratar de realizar el perdonazo';
      }
      this.isLoading = false;
    }
  }
};
</script>
<style scoped>
.card {
  display: flex;
  flex-flow: column wrap;
  align-items: stretch;
  justify-content: flex-start;
  gap: 1rem;
  padding: 1.5rem;
}
#modifier-items {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  gap: 0.5rem;
}
#modifier-items div {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-around;
  gap: 0rem 0.3rem;
}
.text {
  width: 5rem;
}
.help {
  text-align: center;
}
  @media (max-width: 450px) {
  .card {
    padding: 3%;
  }
  #modifier-items {
    flex-flow: column wrap;
    align-items: center;
    justify-content: space-around;
    gap: 1rem;
  }
  }
</style>
